'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {IrregularitiesIndexCtrl} from "./irregularitiesindexctrl.js";
EwSiteApp.controller('IrregularitiesIndexCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", "$mdDialog", IrregularitiesIndexCtrl]);

import {IrregularityInfoCtrl} from "./irregularityinfoctrl.js";
EwSiteApp.controller('IrregularityInfoCtrl', ["$scope", "$http", "$filter", "$mdDialog", "jsDataService", IrregularityInfoCtrl]);

import {IrregularityEditCtrl} from "./irregularityeditctrl.js";
EwSiteApp.controller('IrregularityEditCtrl', ["$scope", "$http", "$filter", "$mdDialog", "jsDataService", IrregularityEditCtrl]);

import {AttachmentCtrl} from "./attachmentctrl.js";
EwSiteApp.controller('AttachmentCtrl', ["$scope", "$http", "$mdDialog", "$filter", "notify", "jsDataService", AttachmentCtrl]);